import { useMutation } from '@tanstack/react-query';

import { type TierChangeRequestBody, type TierChangeResponse, changeTier } from '~/services/LuxLoyalty';

interface UseChangeTierOptions {
  onSuccess?: (data: TierChangeResponse) => void;
  onError?: (error: Error) => void;
}

export function useChangeTier(options: UseChangeTierOptions = {}) {
  return useMutation({
    mutationFn: async (params: TierChangeRequestBody) => {
      return await changeTier(params);
    },
    onSuccess: options.onSuccess,
    onError: options.onError,
  });
}
